<!--
 * @Description: 
 * @Author: liulan
 * @Date: 2021-06-03 18:01:00
 * @LastEditors: liulan
 * @LastEditTime: 2021-06-09 11:26:32
 * @FilePath: \new_storage\xingmahui_front\src\views\contents\tools\feedRecord\sweepCodeFail.vue
 * Copyright (C) 2021 liulan. All rights reserved.
-->
<template>
  <div class="sweep_code_fail_page">
    <header class="header"><img @click="goBack" src="./../../../../assets/images/canEat/arrow_left.png" alt=""></header>
    <section class="section">
      <div class="toast_message">
        <div class="message">
          对不起，系统暂时未能识别该奶粉品牌，试试手动添加
        </div>
      </div>
      <!--  -->
      <div class="scanQR">
        <div class="qr_btn">
          <div class="sweep_code btn" @click="sweepCode">
            <span class="sweep_icon"><img src="./../../../../assets/images/feedRecord/sweep_code.png" alt=""></span>
            <font>扫码添加</font>
          </div>
          <div class="modification_margin btn" @click="modificationMargin">
            <span class="add_icon"><img src="./../../../../assets/images/feedRecord/add_icon.png" alt=""></span>
            <font>修改余量</font>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'SweepCodeFail',
    data() {
      return {}
    },
    methods: {
      goBack() {
        this.$router.back()
      },
      sweepCode() { // 扫码添加

      },
      modificationMargin() { // 修改余量
        this.$router.push({path: '/manuallyAdd'})

      },
    }
  }
</script>

<style lang="less" scoped>
.sweep_code_fail_page {
  width: 100%;
  height: 100%;
  background: #F2F2F2;
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    display: none;
  }
  .header {
    width: 100%;
    height: 52px;
    padding: 15px 13px 17px;
    box-sizing: border-box;
    background: #FFFFFF;
    >img {
      width: 10px;
      height: 20px;
    }
  }
  .section {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    background: #FFFFFF;
    .toast_message {
      width: 100%;
      padding: 59px 100px 70px 107px;
      box-sizing: border-box;
      .message {
        font-size: 14px;
        color: #333333;
        line-height: 28px;
      }
    }
    .scanQR {
      width: 100%;
      padding: 14px 0px  14px 0;
      box-sizing: border-box;
      .qr_btn {
        width: 100%;
        display: flex;
        justify-content: center;
        .btn {
          width: 132px;
          height: 36px;
          background: #D7A85C linear-gradient(132deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
          border-radius: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          &.sweep_code {
            margin-right: 31px;
          }
          .sweep_icon {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            margin-right: 4px;
            >img {
              width: 16px;
              height: 16px;
            }
          }
          .add_icon {
            width: 13px;
            height: 16px;
            display: flex;
            align-items: center;
            margin-right: 4px;
            >img {
              width: 13px;
              height: 16px;
            }
          }
          >font {
            height: 36px;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 36px;
          }
        }
      }
    }
  }
}
</style>